import { LOCAL, RELEASE } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig.js';

const environment = import.meta.env.MODE;

const originalImageKey = 'ai/input/video/';
export default {
    originalImageKey: originalImageKey,
    resultVideoKey: 'ai/export/video/',
    resultCoverKey: 'ai/export/video/cover/',
    resultVideoEffectKey: 'ai/export/video-effect/',
    resultVideoEffectCoverKey: 'ai/export/video-effect/cover/',
    historyListType: '14,28',
    videoEffectJobType: 28,
    freeLimitType: 'video-generator',
    currentMenuName: 'ai-video-generator',

    presetPreviewPath:
        environment === LOCAL ? `/public/resource/ai-video-generator/` : `/app/ai-tools/resource/ai-video-generator/`,
    presetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-generator/AIVideoGeneratorPresetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/ai-video-generator/AIVideoGeneratorPresetList.json?v=${FJVersionConfig.staticPathVersion}`,
    modelPreviewPath:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-video-generator/models/`
            : `https://www.smartvideomaker.com/app/ai-tools/resource/ai-video-generator/models/`,

    videoEffectPresetPath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-generator/ai-video-effect-preset.json`
            : `/app/ai-tools/preloadData/ai-video-generator/ai-video-effect-preset.json`,
    videoEffectDanceStylePreviewPath:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-video-effect/danceStyle/`
            : `https://www.smartvideomaker.com/app/ai-tools/resource/ai-video-effect/danceStyle/`,
    motionControlPreviewPath:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-video-generator/motion-control/`
            : `https://www.smartvideomaker.com/app/ai-tools/resource/ai-video-generator/motion-control/`,
    videoEffectDancePresetPath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-generator/ai-video-effect-dance-preset.json`
            : `/app/ai-tools/preloadData/ai-video-generator/ai-video-effect-dance-preset.json`,
    videoEffectStylePath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-generator/ai-video-effect-style.json`
            : `/app/ai-tools/preloadData/ai-video-generator/ai-video-effect-style.json?v=${FJVersionConfig.staticPathVersion}`,
    videoEffectStyleImagePath:
        environment === LOCAL
            ? `/public/resource/ai-video-effect/style/`
            : `/app/ai-tools/resource/ai-video-effect/style/`,
    videoEffectMediaPresetPath:
        environment === LOCAL
            ? `/public/resource/ai-video-effect/preset/`
            : `/app/ai-tools/resource/ai-video-effect/preset/`,

    originImagePath: [
        originalImageKey,
        'ai/export/text2img/',
        'ai/export/img2img/',
        '/app/ai-tools/resource/ai-video-generator/',
    ],

    inspireListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-generator/AIVideoGeneratorInspireList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/ai-video-generator/AIVideoGeneratorInspireList.json?v=${FJVersionConfig.staticPathVersion}`,
    videoEffectBasicPath:
        environment === LOCAL
            ? `/public/resource/ai-video-effect`
            : `https://resource.flexclip.com/app/ai-tools/resource/ai-video-effect/`,
    modelIconPath:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/img/`
            : environment === LOCAL
              ? `https://smartvideomaker.com/app/ai-tools/img/`
              : `/app/ai-tools/img/`,
};
